import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../../constants'
import { AppWrap,MotionWrap } from '../../wrapper/';
import about_data from '../../data/about.json';
import './About.scss';
import Typewriter from 'typewriter-effect';

const About = () => {
  const data = about_data;
  return (
    <>
            
      <h2 className='section-titles'>Meet Me</h2>

      <div className='app__profiles'>
      <div className='about-me' >
      <h1 className='head-text-me'>{data.name}
            <Typewriter 
              options={{
              strings: data.roles,
                autoStart: true,
                loop: true,
              }}
            />
            </h1>
        {data.about.map((paragraph) => (
          <p className='about-paragraph' key={paragraph}>
            {paragraph}
          </p>
        ))}
        </div>
        <motion.div
          whileInView={{ opacity: 1 }}
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.5, type: 'tween' }}
          className='app__profile-item'
        >
          <div className='container'>
            <img loading="lazy" src={images.me} alt="abdellah" />
            <a className='profile-link' href="https://www.mindlapse.ai/" target="_blank" rel="noopener noreferrer">
              <h2 className='bold-text' style={{ marginTop: 20 }}>{data.post}</h2>
            </a>
          </div>
        </motion.div>
        
      </div>
      <h2 className='quote-text'>
        “Any fool can write code that a computer can understand. Good programmers write code <span style={{ color: 'red' }}>// that humans can understand.</span>”<i> -- Martin Fowler</i>
      </h2>
    </>
  )
}


export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__primarybg',
);
